import {amCharts_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/amCharts_template";

declare let ko: any;

export class amChart_featurePoints extends amCharts_template{

    public options: any = {
        "type": "serial",
        "theme": "none",
        "categoryField": "name",
        "rotate": false,
        "startDuration": 1,
        "categoryAxis": {
            "gridPosition": "start",
            "position": "left",
            "fontSize": 35,
            "labelRotation": 65
        },
        "fontFamily": "Lato, sans-serif",
        "columnSpacing": 0,
        "columnWidth": 0.8,

        "labelRotation": 45,
        "graphs": [ {
            /**
             * We start a new stack with this graph
             */
            "newStack": true,
            "balloonText": "done:[[value]]",
            "labelText": "[[value]]",
            "labelPosition": "middle",
            "color": "#253040",
            "fillAlphas": 1,
            "lineAlpha": 0.2,
            "title": "Done",
            "type": "column",
            "valueField": "done",
            "lineColor": "#46C5DB",
            "fontSize": 50,
        }, {
            "balloonText": "inProgress:[[value]]",
            "labelText": "[[value]]",
            "labelPosition": "middle",
            "color": "#253040",
            "fillAlphas": 1,
            "lineAlpha": 0.2,
            "title": "In Progress",
            "type": "column",
            "valueField": "inProgress",
            "lineColor": "#87e4ac",
            "fontSize": 50,
        } ],
        "valueAxes": [ {
            "stackType": "regular",
            "position": "top",
            "axisAlpha": 0,
            "color": "#9f9f9f",
            "totalText": "[[total]]",
            "fontSize": 12,
        } ],
        "legend": {
            "useGraphSettings": false,
            "color": "#9f9f9f",
            "fontSize": 35,
        },

    };

    public getTemplateName(): string{
        return "feature-points-template";
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/amChart_featurePoints.ts